import {Box, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FieldEditorHeader} from './FieldEditorHeader'

interface FieldEditorErrorProps {
  onBack: () => void
}

/**
 * FieldEditorError Component
 *
 * Error state displayed when a field configuration is not found.
 */
export const FieldEditorError: React.FC<FieldEditorErrorProps> = ({onBack}) => {
  const {t} = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '32px'
      }}
    >
      <FieldEditorHeader onBack={onBack} />
      <Box
        sx={{
          padding: '16px',
          backgroundColor: '#fef2f2',
          borderRadius: '8px'
        }}
        data-test-id="field-editor-error"
      >
        <Typography
          sx={{
            color: '#da0901',
            fontSize: '14px',
            fontWeight: 500
          }}
        >
          {t('orderIntake.rmc.orderManagement.fieldNotFound', 'Field configuration not found')}
        </Typography>
      </Box>
    </Box>
  )
}
